(() => {
  if (window.__roumelB2BEnhancerLoaded) {
    return;
  }

  window.__roumelB2BEnhancerLoaded = true;

  const FORM_SELECTOR = 'spark-form[data-roumel-b2b-form]';
  const STYLE_ID = 'roumel-sparklayer-b2b-overrides';
  const pendingHosts = new WeakSet();
  const rootObservers = new WeakMap();

  /*
    Πεδία του SparkLayer που δεν θέλουμε στην αίτηση συνεργασίας.
    Το βασικό #field-country ΔΕΝ κρύβεται: είναι υποχρεωτικό και από αυτό
    παίρνουν τιμή η χώρα διεύθυνσης και η χώρα ΑΦΜ. Κρυμμένο έμενε κενό και
    η υποβολή κοβόταν με γενικό μήνυμα σε πεδίο που δεν φαινόταν.
    Κρύβουμε αντί γι' αυτό τα αντίγραφα μέσα στη διεύθυνση (χώρα, όνομα,
    επώνυμο, εταιρεία), που συμπληρώνονται αυτόματα από τα πάνω πεδία.
  */
  const HIDDEN_FIELD_SELECTORS = [
    '[name="address_title"]',
    '[name="address_first_name"]',
    '[name="address_last_name"]',
    '[name="address_company"]',
    '[name="address_address_line2"]',
    '#field-address_country_code',
  ];

  const ERRORS_CLASS = 'roumel-b2b-form-errors';
  const SUMMARY_PATTERN = /Διορθώστε|Please fix/i;

  const shadowCss = `
    :host {
      display: block;
      color: var(--spark-form-primary-color, #21170f);
    }

    .spark-form-wrapper {
      padding: 0 !important;
    }

    .spark-form-wrapper > div:first-child {
      margin-bottom: 16px !important;
    }

    .spark-form-wrapper [class~="space-y-4"] > :not([hidden]) ~ :not([hidden]) {
      margin-top: 11px !important;
    }

    .spark-form-wrapper [class~="space-y-2.5"] > :not([hidden]) ~ :not([hidden]) {
      margin-top: 6px !important;
    }

    .spark-form-wrapper [class~="mt-2.5"] {
      margin-top: 6px !important;
    }

    .spark-form-wrapper [class~="mb-6"] {
      margin-bottom: 16px !important;
    }

    .spark-form-wrapper [class~="mt-8"] {
      margin-top: 16px !important;
    }

    .spark-form-wrapper [class~="pt-6"] {
      padding-top: 0 !important;
    }

    .spark-form-wrapper h1 {
      margin: 0 !important;
      color: var(--spark-form-header-color, #21170f) !important;
      font-size: 1.55rem !important;
      line-height: 1.12 !important;
      letter-spacing: 0 !important;
    }

    .spark-form-wrapper h1 + p,
    .spark-form-wrapper header + p {
      max-width: 36ch;
      margin-top: 10px !important;
      color: #6f6256 !important;
      font-size: 0.84rem !important;
      line-height: 1.55 !important;
    }

    .spark-form-wrapper section {
      display: grid !important;
      gap: 13px !important;
    }

    .spark-form-wrapper fieldset {
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
    }

    .spark-form-wrapper fieldset + fieldset {
      margin-top: 2px !important;
    }

    /*
      Πεδία που δεν χρειαζόμαστε στην αίτηση συνεργασίας.
      Κρύβουμε ολόκληρο το wrapper (label + input) ώστε να μην μένει κενό
      στο grid της φόρμας. Και τα δύο πεδία είναι προαιρετικά.
    */
    .spark-form-wrapper div:has(> div > input[name="address_title"]),
    .spark-form-wrapper div:has(> div > input[name="address_first_name"]),
    .spark-form-wrapper div:has(> div > input[name="address_last_name"]),
    .spark-form-wrapper div:has(> div > input[name="address_company"]),
    .spark-form-wrapper div:has(> div > input[name="address_address_line2"]),
    .spark-form-wrapper div:has(> div > div > button[id="field-address_country_code"]) {
      display: none !important;
    }

    .spark-form-wrapper label {
      color: #21170f !important;
      font-size: 0.76rem !important;
      font-weight: 800 !important;
      letter-spacing: 0 !important;
      line-height: 1.25 !important;
      text-transform: none !important;
    }

    .spark-form-wrapper legend {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      white-space: nowrap !important;
    }

    .spark-form-wrapper label.text-error,
    .spark-form-wrapper .text-error {
      color: var(--spark-form-error-color, #9d2f2f) !important;
    }

    .spark-form-wrapper input,
    .spark-form-wrapper textarea,
    .spark-form-wrapper button[id^="field-"] {
      min-height: 42px !important;
      border-radius: 6px !important;
      box-shadow: none !important;
      font-size: 0.86rem !important;
    }

    .spark-form-wrapper input,
    .spark-form-wrapper textarea {
      border-color: #e7d8c3 !important;
      background: #fffdf9 !important;
    }

    .spark-form-wrapper input:hover,
    .spark-form-wrapper textarea:hover,
    .spark-form-wrapper button[id^="field-"]:hover {
      border-color: #d5bf9f !important;
    }

    .spark-form-wrapper input:focus,
    .spark-form-wrapper textarea:focus,
    .spark-form-wrapper button[id^="field-"]:focus {
      border-color: #b47720 !important;
      box-shadow: 0 0 0 3px rgba(180, 119, 32, 0.16) !important;
    }

    .spark-form-wrapper [aria-invalid="true"] {
      border-color: var(--spark-form-error-color, #9d2f2f) !important;
      background: #fff7f5 !important;
    }

    .spark-form-wrapper [role="alert"] {
      margin-top: 4px !important;
      color: var(--spark-form-error-color, #9d2f2f) !important;
      font-size: 0.76rem !important;
      line-height: 1.35 !important;
    }

    .spark-form-wrapper [role="listbox"] {
      border-color: #e7d8c3 !important;
      border-radius: 8px !important;
      box-shadow: 0 14px 34px rgba(61, 36, 24, 0.13) !important;
    }

    .spark-form-wrapper [role="option"] {
      color: #21170f !important;
      font-size: 0.86rem !important;
    }

    .spark-form-wrapper [role="option"]:hover,
    .spark-form-wrapper [role="option"]:focus {
      background: #f5eee4 !important;
    }

    .spark-form-wrapper footer {
      margin-top: 18px !important;
      padding-top: 0 !important;
      border-top: 0 !important;
    }

    .spark-form-wrapper nav {
      display: block !important;
    }

    .spark-form-wrapper nav button,
    .spark-form-wrapper button[aria-busy] {
      width: 100% !important;
      min-height: 46px !important;
      justify-content: center !important;
      border-color: #b47720 !important;
      border-radius: 6px !important;
      background: #b47720 !important;
      color: #fffaf1 !important;
      font-size: 0.88rem !important;
      font-weight: 800 !important;
      letter-spacing: 0 !important;
      line-height: 1 !important;
      text-transform: none !important;
    }

    .spark-form-wrapper nav button:hover,
    .spark-form-wrapper button[aria-busy]:hover {
      border-color: #7b4a25 !important;
      background: #7b4a25 !important;
    }

    .spark-form-wrapper nav button[disabled],
    .spark-form-wrapper button[aria-busy="true"] {
      cursor: wait !important;
      opacity: 0.78 !important;
    }

    .spark-form-wrapper h6 {
      margin: 12px 0 0 !important;
      color: var(--spark-form-error-color, #9d2f2f) !important;
      font-size: 0.78rem !important;
      font-weight: 800 !important;
      letter-spacing: 0 !important;
      line-height: 1.35 !important;
      text-align: center !important;
    }

    .fixed.z-50 {
      background: #b47720 !important;
    }

    @media (max-width: 749px) {
      .spark-form-wrapper input,
      .spark-form-wrapper textarea,
      .spark-form-wrapper button[id^="field-"],
      .spark-form-wrapper nav button {
        min-height: 46px !important;
        font-size: 16px !important;
      }
    }
  `;

  /*
    Η φόρμα γίνεται render από React μέσα στο shadow DOM και το React κρατά
    αναφορές στα text nodes του. Με `element.textContent = ...` το υπάρχον text
    node καταστρέφεται και αντικαθίσταται από νέο, οπότε το επόμενο render
    (π.χ. στην υποβολή) σκάει με "Failed to execute 'insertBefore' on 'Node'".
    Γράφουμε λοιπόν μέσα στο ίδιο node, χωρίς να αλλάξουμε τη δομή.
  */
  function textNodeOf(element) {
    const [firstChild] = element.childNodes;

    if (element.childNodes.length === 1 && firstChild?.nodeType === Node.TEXT_NODE) {
      return firstChild;
    }

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => (node.nodeValue?.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });

    return walker.nextNode();
  }

  function setText(element, value) {
    if (!element || !value || element.textContent.trim() === value) {
      return;
    }

    const textNode = textNodeOf(element);

    /* Χωρίς text node δεν πειράζουμε τίποτα — καλύτερα αμετάφραστο παρά crash. */
    if (textNode) {
      textNode.nodeValue = value;
    }
  }

  function setKnownText(element, value, knownValues) {
    if (!element || !value) {
      return;
    }

    const current = element.textContent.trim();

    if (current === value || knownValues.includes(current)) {
      setText(element, value);
    }
  }

  function setButtonLabel(button, label, configuredLabel) {
    if (!button || !label) {
      return;
    }

    if (button.getAttribute('aria-busy') === 'true') {
      return;
    }

    const current = button.textContent.trim();
    const canReplace =
      current === 'Submit' ||
      current === 'Υποβολή' ||
      current === 'Υποβολή αίτησης' ||
      current === configuredLabel ||
      button.getAttribute('aria-label') === 'Submit' ||
      button.getAttribute('aria-label') === 'Υποβολή';

    if (!canReplace) {
      return;
    }

    if (current !== label) {
      setText(button, label);
    }

    button.setAttribute('aria-label', label);
  }

  /*
    Βρίσκει το εξωτερικό wrapper του πεδίου (label + input), ανεβαίνοντας
    όσο ο γονέας δεν περιέχει άλλα πεδία. Έτσι κρύβεται και το κενό που θα
    άφηνε το gap του grid, χωρίς να παρασυρθεί διπλανό πεδίο.
  */
  function fieldWrapper(field) {
    /* Τα select του SparkLayer είναι custom listbox buttons, όχι <select>. */
    const controls = 'input, select, textarea, button[id^="field-"]';
    let wrapper = field.parentElement;

    while (
      wrapper &&
      wrapper.parentElement &&
      !wrapper.parentElement.classList.contains('spark-form-wrapper') &&
      wrapper.parentElement.querySelectorAll(controls).length === 1
    ) {
      wrapper = wrapper.parentElement;
    }

    return wrapper;
  }

  /*
    Η φόρμα γίνεται render από React μέσα στο shadow DOM, οπότε τα πεδία
    ξαναγράφονται. Τρέχουμε σε κάθε mutation και κρύβουμε ό,τι ξαναεμφανιστεί.
  */
  function hideOptOutFields(root) {
    HIDDEN_FIELD_SELECTORS.forEach((selector) => {
      root.querySelectorAll(selector).forEach((field) => {
        const wrapper = fieldWrapper(field);

        /* Έλεγχος στο ίδιο το style, ώστε να ξανακρυφτεί αν το React το επαναφέρει. */
        if (!wrapper || wrapper.style.display === 'none') {
          return;
        }

        /* Πεδίο με σφάλμα δεν κρύβεται ποτέ, αλλιώς ο χρήστης δεν βλέπει τι να διορθώσει. */
        if (field.getAttribute('aria-invalid') === 'true' || wrapper.querySelector('.text-error')) {
          return;
        }

        wrapper.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function applyConfiguredCopy(host) {
    const root = host.shadowRoot;

    if (!root) {
      return;
    }

    hideOptOutFields(root);

    /* Στο /en το roumel-en-content.js δίνει την αγγλική απόδοση των ρυθμίσεων. */
    const translate = (value) => (value && window.roumelTranslate ? window.roumelTranslate(value) : value);
    const { formHeading, formText, submitLabel } = host.dataset;

    setKnownText(root.querySelector('.spark-form-wrapper h1'), translate(formHeading), [
      'Wholesale Registration Form',
      'Φόρμα εγγραφής χονδρικής',
      formHeading,
    ]);

    const intro = root.querySelector('.spark-form-wrapper h1')?.closest('div')?.querySelector('p');
    setKnownText(intro, translate(formText), [
      'Are you a prospective customer? Please fill in the form below to apply for access.',
      'Είστε υποψήφιος πελάτης; Συμπληρώστε την παρακάτω φόρμα για να ζητήσετε πρόσβαση.',
      formText,
    ]);

    root.querySelectorAll('button[aria-label], button[aria-busy]').forEach((button) => {
      setButtonLabel(button, translate(submitLabel), submitLabel);
    });

    /* Τρεις ετικέτες «Χώρα» μπερδεύουν· η χώρα του ΑΦΜ παίρνει δική της. */
    setKnownText(root.querySelector('label[for="field-tax_country"]'), translate('Χώρα ΑΦΜ'), ['Country', 'Χώρα']);

    renderErrorList(host);
  }

  function isVisible(element) {
    return Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  /* Ετικέτες των πεδίων που έχουν σφάλμα, με τη σειρά που εμφανίζονται. */
  function invalidFields(root) {
    const seen = new Set();
    const fields = [];

    root.querySelectorAll('.spark-form-wrapper label.text-error').forEach((label) => {
      const name = label.textContent.replace(/\*/g, '').trim();
      const control = label.htmlFor ? root.getElementById(label.htmlFor) : null;

      if (!name || seen.has(name) || !isVisible(label)) {
        return;
      }

      seen.add(name);
      fields.push({ name, control: control || label });
    });

    return fields;
  }

  /*
    Το SparkLayer δείχνει μόνο «Διορθώστε N σφάλματα παραπάνω». Κάτω από αυτό
    γράφουμε ποια πεδία φταίνε, με σύνδεσμο που πάει στο καθένα. Η λίστα ζει
    έξω από το shadow DOM ώστε να μη μπλέκεται με τα renders του React.
  */
  function renderErrorList(host) {
    const root = host.shadowRoot;
    const summary = [...root.querySelectorAll('.spark-form-wrapper h6, .spark-form-wrapper [role="alert"]')].find(
      (element) => SUMMARY_PATTERN.test(element.textContent)
    );
    const fields = summary ? invalidFields(root) : [];
    let list = host.nextElementSibling?.classList.contains(ERRORS_CLASS) ? host.nextElementSibling : null;

    if (!fields.length) {
      if (list) {
        list.hidden = true;
      }

      return;
    }

    if (!list) {
      list = document.createElement('div');
      list.className = ERRORS_CLASS;
      list.setAttribute('role', 'alert');
      host.after(list);
    }

    const signature = fields.map((field) => field.name).join('|');

    if (list.dataset.signature !== signature) {
      list.dataset.signature = signature;
      list.replaceChildren();

      const title = document.createElement('p');
      title.textContent = window.roumelTranslate
        ? window.roumelTranslate('Ελέγξτε τα παρακάτω πεδία:')
        : 'Ελέγξτε τα παρακάτω πεδία:';
      list.appendChild(title);

      const items = document.createElement('ul');

      fields.forEach((field) => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = field.name;
        button.addEventListener('click', () => focusField(field.control));
        item.appendChild(button);
        items.appendChild(item);
      });

      list.appendChild(items);
    }

    list.hidden = false;

    /* Μετά από πάτημα «Υποβολή» πάμε κατευθείαν στο πρώτο λάθος πεδίο. */
    if (host.__roumelSubmitPending) {
      host.__roumelSubmitPending = false;
      focusField(fields[0].control);
    }
  }

  function focusField(control) {
    if (!control) {
      return;
    }

    control.scrollIntoView({ block: 'center', behavior: 'smooth' });
    window.setTimeout(() => control.focus?.({ preventScroll: true }), 350);
  }

  function watchSubmit(host) {
    if (host.__roumelSubmitWatched) {
      return;
    }

    host.__roumelSubmitWatched = true;
    host.shadowRoot.addEventListener('click', (event) => {
      const button = event.target.closest?.('button');

      if (button && (button.closest('nav, footer') || button.hasAttribute('aria-busy'))) {
        host.__roumelSubmitPending = true;
        window.setTimeout(() => {
          host.__roumelSubmitPending = false;
        }, 10000);
      }
    });
  }

  function injectShadowStyles(host) {
    const root = host.shadowRoot;

    if (!root) {
      return false;
    }

    if (!root.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = shadowCss;
      root.appendChild(style);
    }

    watchSubmit(host);
    applyConfiguredCopy(host);

    if (!rootObservers.has(root)) {
      const observer = new MutationObserver(() => {
        if (!root.getElementById(STYLE_ID)) {
          const style = document.createElement('style');
          style.id = STYLE_ID;
          style.textContent = shadowCss;
          root.appendChild(style);
        }

        applyConfiguredCopy(host);
      });

      observer.observe(root, {
        childList: true,
        characterData: true,
        subtree: true,
      });

      rootObservers.set(root, observer);
    }

    return true;
  }

  function waitForShadow(host, attempt = 0) {
    if (injectShadowStyles(host)) {
      pendingHosts.delete(host);
      return;
    }

    if (attempt >= 9) {
      pendingHosts.delete(host);
      return;
    }

    window.setTimeout(() => waitForShadow(host, attempt + 1), Math.min(700, 60 * 2 ** attempt));
  }

  function enhanceHost(host) {
    if (!host || pendingHosts.has(host)) {
      return;
    }

    if (injectShadowStyles(host)) {
      return;
    }

    pendingHosts.add(host);

    if (window.customElements?.whenDefined) {
      window.customElements.whenDefined('spark-form').then(() => waitForShadow(host));
      return;
    }

    waitForShadow(host);
  }

  function setup(scope = document) {
    scope.querySelectorAll?.(FORM_SELECTOR).forEach(enhanceHost);
  }

  function disconnectSection(section) {
    section.querySelectorAll?.(FORM_SELECTOR).forEach((host) => {
      const root = host.shadowRoot;
      const observer = root && rootObservers.get(root);

      if (observer) {
        observer.disconnect();
        rootObservers.delete(root);
      }
    });
  }

  const pageObserver = new MutationObserver(() => setup());

  document.addEventListener('DOMContentLoaded', () => setup());
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:section:unload', (event) => disconnectSection(event.target));

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  setup();
})();
